
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Agendas, UploadedEvidence} from "../../model/agendas";
import { AuthService } from '../AuthService/auth-service.service';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class AgendasService {
  dataStore:{selectedAgendas:Agendas[], uploadedEvidence:UploadedEvidence[], masterAgenda:string}
  _allAgendas: BehaviorSubject<any>
  _selectedAgendas: BehaviorSubject<any>
  _masterAgenda: BehaviorSubject<any>
  agendaInfo: any
  currentURL='';
  _showSpinner: BehaviorSubject<boolean>;
  options:any;  
  filtered:Agendas[];
  
  constructor(private http: HttpClient) {
    this.currentURL = window.location.origin.includes('localhost')? "": environment.BaseURL;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'});
      this.options = { headers: headers };
      this.dataStore={selectedAgendas:[], uploadedEvidence:[], masterAgenda:""}
      this.agendaInfo=[];
      this._allAgendas = <BehaviorSubject<any>>new BehaviorSubject(this.agendaInfo)
      this._selectedAgendas = <BehaviorSubject<any>>new BehaviorSubject([])
      this._masterAgenda = <BehaviorSubject<any>>new BehaviorSubject([])
      this._showSpinner = <BehaviorSubject<any>>new BehaviorSubject(false);
  }

  get agendas(){
    return this._allAgendas.asObservable()
  }

  getSelectedAgendas(): Agendas[]{
    return this.dataStore.selectedAgendas
  }

  get selectedAgendas(){
    return this._selectedAgendas.asObservable()
  }

  clearAll(){
    this._selectedAgendas.next(Object.assign([], []))
    this._allAgendas.next(Object.assign([], []))
  }

  setSelectedAgendas(agenda:Agendas){
    if(agenda==null){
      this.dataStore.selectedAgendas=[];
    }
    else{
      if(this.dataStore.selectedAgendas.includes(agenda)){
        this.dataStore.selectedAgendas.splice(this.dataStore.selectedAgendas.indexOf(agenda), 1);
      }
      else{
        this.dataStore.selectedAgendas.push(agenda)
        this.dataStore.selectedAgendas.sort(
          (a, b) => (a.agenda > b.agenda) ? 1 : -1
        )
      }
    }
    this.dataStore.selectedAgendas =this.dataStore.selectedAgendas.sort((a, b) => a.agenda.localeCompare(b.agenda))
    this._selectedAgendas.next(Object.assign({}, this.dataStore).selectedAgendas)
    this.dataStore.masterAgenda = (this.dataStore.selectedAgendas.length> 0)? this.dataStore.selectedAgendas[0].agenda : ""
    this._masterAgenda.next(Object.assign({}, this.dataStore).masterAgenda)
    return this.dataStore.selectedAgendas[0] || null
  }

  unselectAgendas(){
    this.dataStore.selectedAgendas =[]
    this.dataStore.masterAgenda =  (this.dataStore.selectedAgendas.length> 0)? this.dataStore.selectedAgendas[0].agenda : ""
    this._masterAgenda.next(Object.assign({}, this.dataStore).masterAgenda)
    this._selectedAgendas.next(Object.assign({}, this.dataStore).selectedAgendas)
  }

  selectAllAgendas(){
    this.dataStore.selectedAgendas = this.filtered
    this.dataStore.selectedAgendas =this.dataStore.selectedAgendas.sort((a, b) => a.agenda.localeCompare(b.agenda))
    this._selectedAgendas.next(Object.assign({}, this.dataStore).selectedAgendas)
    this.dataStore.masterAgenda =  (this.dataStore.selectedAgendas.length> 0)? this.dataStore.selectedAgendas[0].agenda : ""
    this._masterAgenda.next(Object.assign({}, this.dataStore).masterAgenda)
    return this.dataStore.selectedAgendas[0]
  }

  filterAgendas(heardFiltered:string, searchValue:string, sorting:string, date:string, selectedHearingRoom:string){
    console.log('Agenda Filtered by ::::     heard:'+heardFiltered +'   value:'+ (searchValue? searchValue :'empty Search ')+'   srt:'+ sorting+'   date:'+ date +'   room:'+selectedHearingRoom )


    //Search Criteria
    if(searchValue !== '')
      this.filtered = Object.assign([], this.agendaInfo.filter(x => x.agenda.includes(searchValue)) ) 
    else 
      this.filtered = Object.assign([], this.agendaInfo  )
    
    //Sorting
    // if(sorting === 'Petition'  && filtered.length > 0){
    //   filtered = filtered.sort((n1,n2) => (n1.agenda > n2.agenda ? 1 : -1));
    // }
    // else if(sorting === 'HearingDate' && filtered.length > 0){
    //   filtered = filtered.sort((n1,n2) => (new Date(n1.hearingDate) > new Date(n2.hearingDate) ? 1 : -1));
    // }
    //Filter
    if(heardFiltered == 'Heard Petitions'){
      let todaysDate = new Date();
      todaysDate.setHours(0,0,0,0);
      this.filtered =this.filtered.filter(x => new Date(x.hearingDate) <= todaysDate && x.hearingDate !== null)
    } 
    else if(heardFiltered == 'Unheard Petitions'){
      let todaysDate = new Date();
      todaysDate.setHours(0,0,0,0);
      this.filtered =this.filtered.filter(x => new Date(x.hearingDate) > todaysDate && x.petitionStatus == "SC")
    }
    else if(heardFiltered == 'UnScheduled Petitions'){
      this.filtered =this.filtered.filter(x => x.hearingDate === null && x.petitionStatus !== 'WD' && x.petitionStatus !== 'NP' && x.petitionStatus !== 'CN' && x.petitionStatus !== 'NH')
    }
    else if(heardFiltered == 'All'){
      this.filtered = this.filtered.sort((n1,n2) => (n1.agenda < n2.agenda ? -1 : 1));
      this.filtered =this.filtered.reverse();
    }

    //Sorting for all other than All
    if(heardFiltered !== 'All') {
        this.filtered = this.filtered.sort((n1,n2) => {
        return new Date(n1.hearingDate) > new Date(n2.hearingDate) ? 1 : -1 || (n1.agenda < n2.agenda)? 1: -1;
      });
    }

    if(date){
      this.filtered = this.filtered.filter(x => new Date(x.hearingDate).toDateString() === new Date(date).toDateString())
    }
    
    if(selectedHearingRoom !== 'All'){
      this.filtered =this.filtered.filter(x => x.hearingRoom.includes(selectedHearingRoom))
    }

    this._allAgendas.next(Object.assign([], this.filtered ))
    this._showSpinner.next(false);
  }

  getAllAgendas(agentId:string){ 
    this._showSpinner.next(true);
    this.http.get<any>( this.currentURL + environment.GetAllAgendas + agentId, this.options).subscribe(data => {
      this.agendaInfo = data
      this.filterAgendas('Unheard Petitions','', 'HearingDate', null,'All');
    },
    err=>{
      this._showSpinner.next(false);
    });
  }
}
